import React from "react";
import {Redirect} from 'react-router-dom';
import Pagination from "react-js-pagination";
import moment from 'moment';
import {Link} from 'react-router-dom';
import * as Util from '../common/Util';
import InvalidAccessOrLogin from "../errorsPage/InvalidAccessOrLogin";
/*
var BarChart = require("react-chartjs").Bar;
*/

class Payments extends React.Component {

    constructor(params)     {
        super(params);
        this.state = {
            list: [],
            blubillingConf: {},
            activeNumber:1,
            lastTenDays:30,
            count:0,
            search:'',
            limit:50,
            apiStatus: {
                isError: false,
                message: ''
            },
            showLoader:false,
            redirectToForbiddenPage: false,
            dashboard: {}
        }
        this.fetchPayments = this.fetchPayments.bind(this)
    }

    fetchPayments(event){
        let activePageNumber = 1;
        let url = this.props.api+"/payment";
        console.log(event);
        if(event !== null && isNaN(event) === true){
            event.preventDefault()
        }else if(event !== null && isNaN(event) === false){
            if(isNaN(parseInt(event + '', 10))===true){
                activePageNumber = 0
            }else{
                activePageNumber = (parseInt(event+'', 10)-1);
                this.setState({activeNumber: event})
            }
        }
        url += "?limit=" + this.state.limit + "&offset=" + activePageNumber
        this.setState({showLoader:true});
        fetch(url,{
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-AUTH-TOKEN': this.props.jwtToken
            }
        })
            .then(response => response.json())
            .then(json => {
                console.log(json);
                this.setState({showLoader: false});
                if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                    this.props.onLogoutClick(json.message);
                } else if (json.httpCode === 403 && json.isError === true && json.message === "Forbidden") {
                    this.setState({showLoader: false, redirectToForbiddenPage: true});
                } else {
                    if (isNaN(event) === false && json.payments && json.payments.content) {
                        this.setState({
                            list: json.payments.content,
                            activeNumber: event,
                            count: json.payments.totalElements
                        });
                    } else {
                        if (json.payments && json.payments.content) {
                            this.setState({list: json.payments.content, count: json.payments.totalElements});
                        }
                    }
                }
            }).catch(error => {
            this.setState({showLoader:false});
            console.log(error);
        });
    }

    componentDidMount() {
        this.fetchPayments(1);
        if(this.props.params && this.props.params.msgType) {
            const {apiStatus} = this.state;
            apiStatus.isError = false;
            apiStatus.message = this.props.params.msg;
            this.setState({apiStatus: apiStatus});
        }
    }

    render() {
        let _this = this;

        return (
            <div>
                <div className="wrapper animated fadeInRight">
                    <div className="row">
                        <InvalidAccessOrLogin jwtToken={this.props.jwtToken}
                                              redirectToForbiddenPage={this.state.redirectToForbiddenPage}/>
                        {this.state.showLoader === true ? (<div className="loading">Loading&#8230;</div>) : ''}
                        <div className="col-lg-12">
                            <div className="dashboard-table-wrap">
                                <div className="heading-wrapper clearfix">
                                    <p className="m-t-xs">{_this.props.msg('payment.title')}</p>
                                </div>
                               {/* <div className="ibox-content">
                                    <div className="row">
                                        <div className="col-lg-12">*/}
                                            {/*<div className="ibox float-e-margins  table-responsive">*/}
                                                <div style={{'textAlign':'center'}}>
                                                  <span
                                                      style={{'color':this.state.apiStatus.isError===true?'red':'green'}}> {this.state.apiStatus.message ? this.state.apiStatus.message : ''}</span>
                                                    <br/>
                                                </div>
                                                <div className="table-box table-responsive p-m">
                                                <table className="table table-condensed-xs">
                                                    <thead>
                                                    <tr>
                                                        <th className="header text-center">{_this.props.msg('payment.Id')}</th>
                                                        <th className="header text-left">{_this.props.msg('payment.signatureRequest')}</th>
                                                        {/*<th className="header text-left">{_this.props.msg('payment.recipient')}</th>*/}
                                                        <th className="header text-left">{_this.props.msg('table.th.blubillingCustomer')}</th>
                                                        <th className="header text-right">{_this.props.msg('payment.amount')}</th>
                                                        <th className="header text-center">{_this.props.msg('payment.status')}</th>
                                                        <th className="header text-center">{_this.props.msg('payment.effectiveDate')}</th>
                                                        <th className="header text-center">{_this.props.msg('payment.bluId')}</th>
                                                        <th className="header text-center">{_this.props.msg('payment.createdUser')}</th>
                                                        <th className="header text-center">{_this.props.msg('payment.note')}</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {this.state.list && this.state.list.map(function(payment, index){
                                                        return (
                                                            <tr key={Math.random()}>
                                                                <td className="text-center" style={{padding:'3px'}}>
                                                                    <Link to={'/payment/detail/'+payment.id} target="_blank" title="View Payment" style={{textDecoration:"underline"}}>
                                                                        {payment.id}
                                                                    </Link>
                                                                </td>
                                                                <td className="text-left">
                                                                    <Link to={'/esignatureDetail/'+payment.signatureRequestId} target="_blank" title="View Signature Request" style={{textDecoration:"underline"}}>
                                                                          {payment.signatureRequestTitle}
                                                                    </Link><br/>
                                                                    {payment.recipient.name} ({payment.recipient.email})
                                                                </td>
                                                               {/* <td className="text-left">
                                                                    {payment.recipient.name} ({payment.recipient.email})
                                                                </td>*/}
                                                                <td className="text-left">
                                                                    <div style={{fontSize:"12px"}}>
                                                                        <p><strong>{(payment.blubillingCustomer && payment.blubillingCustomer.companyName)?payment.blubillingCustomer.companyName:null}</strong></p>
                                                                        {(payment.blubillingCustomer && payment.blubillingCustomer.firstName)?<p>{payment.blubillingCustomer.firstName}&nbsp;{(payment.blubillingCustomer && payment.blubillingCustomer.lastName)?payment.blubillingCustomer.lastName:null}</p>:null}
                                                                        <p>{(payment.blubillingCustomer && payment.blubillingCustomer.email)?payment.blubillingCustomer.email:null}</p>
                                                                    </div>
                                                                </td>
                                                                <td className="text-right">
                                                                    $ {Util.formatMoney(payment.amount)}
                                                                </td>
                                                                <td className="text-center">
                                                                    {payment.status === "PAID" ?<span
                                                                            className="label label-success text-uppercase">PAID</span>
                                                                        :null}

                                                                    {payment.status === "DRAFT" ?<span
                                                                            className="label label-info text-uppercase">DRAFT</span>
                                                                        :null}
                                                                    {payment.status === "ERROR" ?<span
                                                                            className="label label-danger text-uppercase">ERROR</span>
                                                                        :null}
                                                                    {payment.status === "DECLINED" ?<span
                                                                            className="label label-warning text-uppercase">DECLINED</span>
                                                                        :null}
                                                                    {payment.status === "VOIDED" ?<span
                                                                            className="label label-warning text-uppercase">VOIDED</span>
                                                                        :null}
                                                                    {payment.status === "REVERSED" ?<span
                                                                            className="label label-warning text-uppercase">REVERSED</span>
                                                                        :null}
                                                                </td>
                                                                <td className="text-center">
                                                                    {moment(payment.effectiveDate).format("MM/DD/YYYY")}
                                                                </td>
                                                                <td className="text-center">
                                                                    {payment.externalPaymentId}
                                                                </td>
                                                                <td className="text-center">
                                                                    {payment.paymentUser && payment.paymentUser.username ? payment.paymentUser.username : ''}
                                                                </td>
                                                                <td className="text-center">
                                                                    {payment.notes}
                                                                </td>
                                                             </tr>
                                                        );
                                                    })}
                                                    </tbody>
                                                    <tfoot>
                                                    <tr>
                                                        <td colSpan="6" className="footable-visible">
                                                <Pagination
                                                    activePage={this.state.activeNumber}
                                                    itemsCountPerPage={this.state.limit}
                                                    totalItemsCount={this.state.count}
                                                    pageRangeDisplayed={5}
                                                    onChange={this.fetchPayments}
                                                />
                                                        </td>
                                                    </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>

                                    {/*</div>*/}
                                {/*</div>*/}

                            {/*</div>*/}
                        </div>
                    </div>
                </div>
                <style dangerouslySetInnerHTML = {{__html: `
                p { margin:0 0 2px;}
                .table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {
                  padding: 4px;
                }

                .center{ text-align:center }
                .left{ text-align:left }
                .right{ text-align:right }
                `}} />
            </div>
        )
    }
}

export default Payments;



// WEBPACK FOOTER //
// ./src/components/payment/Payments.js